import React, { Suspense } from 'react'
import { pick } from 'lodash-es'
import { useAppEx } from '@vt/hooks'
// import { routeTo } from '@vt/utils'
import useRouteTo from '../hooks/navigation/use-route-to'
import { NavStoreProvider } from '../menu/NavStoreProvider'
import { MainNav } from '../menu'

export default function AppWithNav({
  children,
  customComp,
  hiddenNavs = false,
}) {
  const { currentNav, appId } = useAppEx((x) =>
    pick(x, ['currentNav', 'appId'])
  ) // 纵向导航数据

  const { routeTo } = useRouteTo({ appId })

  if (!currentNav || !currentNav.navs) {
    return (
      <div className="w-full">
        <div className="text-[14px] pt-[10px] pl-[20px]">导航数据获取出错</div>
        {children}
      </div>
    )
  }

  return (
    <div
      className="relative w-full h-screen flex flex-col"
      data-spec="app-with-nav"
    >
      {/* 根据导航配置字段渲染对应导航 */}
      <NavStoreProvider>
        <MainNav
          appId={appId}
          menuData={currentNav.navs}
          rightElements={currentNav.rightElements}
          hiddenNavs={hiddenNavs}
          onMenuSelect={(nav) => {
            // routeTo(nav, appId, navigate)
            routeTo(nav)
          }}
          navType={currentNav.navType}
          mainNav={currentNav.mainNav}
          mainNavRenderLevel={currentNav.mainNavRenderLevel}
          secondNavRenderLevel={currentNav.secondNavRenderLevel}
        >
          {/* 这里可以设计一个 loading 或者留白 */}
          <Suspense fallback={<div>...</div>}>
            <div className="flex flex-col w-full h-full flex-1">
              {children}
              {customComp}
            </div>
          </Suspense>
        </MainNav>
      </NavStoreProvider>
    </div>
  )
}
